import React from 'react'
import { isMobile } from 'react-device-detect'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  DcTabs,
  PixelPageContainer,
  Section,
  SectionContent,
} from 'pixel-base'

import Configurations from './components/Configurations'
import EventSubscriptions from './components/EventSubscriptions'
import NotificationHistory from './components/NotificationHistory'

interface Tab {
  name: string
  title: string
  component: JSX.Element
}

const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'WhatsApp',
    active: true,
  },
]

const WhatsApp: React.FC = () => {
  const whatsAppTabs: Record<string, Tab> = {
    configurations: {
      name: 'configurations',
      title: 'Configurations',
      component: <Configurations />,
    },
    eventSubscriptions: {
      name: 'Event Subscriptions',
      title: 'Event Subscriptions',
      component: <EventSubscriptions />,
    },
    notificationHistory: {
      name: 'History',
      title: 'History',
      component: <NotificationHistory />,
    },
  }

  const [activeTabs, setActiveTabs] = React.useState<string>('configurations')

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }} isMobile={isMobile}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox height="auto" padding="0px 20px">
              <DcTabs
                variant="simple"
                size="md"
                tabs={Object.keys(whatsAppTabs).map((tabKey) => ({
                  label: whatsAppTabs[tabKey].title,
                  value: tabKey,
                }))}
                activeTab={activeTabs}
                handleChange={(newTab: string) => setActiveTabs(newTab)}
              />
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} isMobile={isMobile}>
          <SectionContent isMobile={isMobile}>
            {whatsAppTabs[activeTabs].component}
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default WhatsApp
